// extracted by mini-css-extract-plugin
export default {"label":"FP5c79sO","disabled":"NZlUi3Mu","inline":"eALZjBy9","inline-left":"hUqbD7nz","inlineLeft":"hUqbD7nz","inline-right":"Bkdjact3","inlineRight":"Bkdjact3"};